import { EventProps } from 'react-big-calendar';
import { CalendarEvent } from '../../utils/calendarHelpers';

interface CustomEventComponentProps extends EventProps<CalendarEvent> {}

export function CustomEventComponent({ event }: CustomEventComponentProps) {
  return (
    <div className="px-2 py-1 h-full">
      <span className="truncate text-xs font-medium" title={event.title}>
        {event.title}
      </span>
    </div>
  );
}
